import { AudioLines } from "lucide-react";

import type { Assistant } from "../../api";
import SettingsSheet from "./SettingsSheet";
import { ToggleRow, SliderRow, Segmented } from "./controls";
import { BACKGROUND_SOUNDS } from "./options";
import ProviderPicker from "./ProviderPicker";
import VoicePicker from "./VoicePicker";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  assistant: Assistant;
};

/** Voice (text-to-speech) settings drawer. */
export default function VoiceSettings({ open, onOpenChange, assistant }: Props) {
  return (
    <SettingsSheet
      open={open}
      onOpenChange={onOpenChange}
      title="Voice"
      description="The text-to-speech voice the assistant speaks with."
      icon={<AudioLines className="size-4 text-fuchsia-500" />}
    >
      <ProviderPicker
        kind="voice"
        assistant={assistant}
        current={assistant.voice}
        patchKey="voice_id"
        optionLabel="TTS model"
      />

      <div className="border-t pt-4">
        <VoicePicker assistant={assistant} />
      </div>

      <div className="border-t pt-4">
        <SliderRow
          label="Speed"
          description="How fast the assistant speaks."
          min={0.5}
          max={2}
          step={0.05}
          defaultValue={1.1}
          minLabel="Slower"
          maxLabel="Faster"
          format={(v) => `${v.toFixed(2)}x`}
        />
      </div>

      <div className="border-t pt-4">
        <Segmented
          label="Background sound"
          description="Ambient audio played under the call."
          options={BACKGROUND_SOUNDS}
          defaultValue="Off"
        />
      </div>

      <div className="border-t pt-4">
        <ToggleRow
          label="Fallback voice"
          description="Use a backup voice if the primary voice fails."
          defaultChecked
        />
      </div>
    </SettingsSheet>
  );
}
